export default __webpack_public_path__ + "media/images/logo-508fe2197d6eddb12d4ea485d1295aa4.svg";